import styled from 'styled-components';
import { AlignCenter } from '../../global/commonStyle';
import { Typography } from '../../global/theme';

interface Props {
  isTaskDetail?: boolean;
}

export const Bottom = styled.div<Props>`
  position: fixed;
  bottom: 32px;
  width: ${({ isTaskDetail }) => (isTaskDetail ? 'calc(100vw - 560px)' : '-webkit-fill-available')};
  z-index: var(--z-index-header);
`;

export const SelectBox = styled.div`
  width: max-content;
  padding: var(--space-8) var(--space-8) var(--space-8) var(--space-12);
  border: 0.5px solid var(--border-primary);
  box-shadow: var(--shadow-modal);
  border-radius: var(--border-radius-12);
  margin-inline: auto;
  background-color: var(--background-primary);
  ${AlignCenter}
  gap: var(--space-16);
`;

export const SelectedTask = styled.p`
  ${Typography.body_md_medium}
  color: var(--text-primary);
  margin: var(--space-0);
`;

export const RightSection = styled.div`
  display: flex;
  gap: var(--space-8);
`;

export const BulkAction = styled.div`
  padding-inline: var(--space-8);
  display: flex;
  gap: var(--space-12);
  border-right: 0.5px solid var(--border-primary);
  .active-dropdown {
    background-color: var(--neutral-secondary);
    svg path {
      fill: var(--text-primary);
    }
  }
  .active-status-dropdown {
    background-color: var(--neutral-secondary);
    svg {
      filter: brightness(var(--brightness-value));
      .transparent-fill {
        fill: none;
      }
      .desktop-fill {
        fill: transparent;
      }
    }
  }
`;
